<template>
    <transition appear enter-active-class="animated bounceInRight">
        <f7-view main>
            <f7-page>
                <!-- header -->
                <cm-navbar :title="$ml.get('listOrders')">
                    <f7-nav-right><f7-link @click="getData"><i class="f7-icons">refresh</i></f7-link></f7-nav-right>
                </cm-navbar>
                <!-- END header -->

                <f7-toolbar tabbar bottom>
                    <f7-link tab-link="#tab-1" tab-link-active>{{ $ml.get('listOrders') }}</f7-link>
                    <f7-link tab-link="#tab-2">{{ $ml.get('customer') }}</f7-link>
                </f7-toolbar>

                <f7-tabs animated>
                    <f7-tab id="tab-1" class="page-content" tab-active>
                        <div class="__row">
                            <div v-for="(order, index) in orders" :key="'num11' + index" class="column">
                                <div v-for="(item, index2) in order.data" :key="'num12' + index2" @click="viewDetail(item.customer)" v-bind:class="{highlightBox: highlight(item.detail)}">
                                    <div class="display-flex justify-content-space-between margin-horizontal">
                                        <span class="customer_name">{{ item.customer.name }}</span>
                                        <span class="estimated_day" v-bind:class="{highlightDay: highlight(item.detail)}">{{ item.estimated_day }}</span>
                                    </div>
                                    <ul class="so_detail">
                                        <li v-for="(detail, index3) in item.detail" :key="'num13' + index3" class="display-flex justify-content-space-between margin-horizontal" >
                                            <span>{{ detail.material.name }}</span>
                                            <strong>{{ detail.round_amount }}({{ detail.packingdetail.value }})</strong>
                                        </li>
                                    </ul>
                                    <div class="display-flex justify-content-space-between margin-horizontal" v-if="item.shipping_unit">
                                        <span class="customer_name">{{ item.shipping_unit }}</span>
                                    </div>
                                    <div class="display-flex justify-content-space-between margin-horizontal" v-if="item.notes">
                                        <span>Ghi chú: {{ item.notes }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </f7-tab>

                    <f7-tab id="tab-2" class="page-content">
                        <f7-searchbar
                            search-container=".search-list"
                            search-in=".item-title"
                            :disable-button="!$theme.aurora"
                            ></f7-searchbar>
                        <f7-list class="customer_list search-list searchbar-found">
                            <f7-list-item v-for="(item, index) in listSort"
                                :key="index"
                                :title="item.name"
                                :badge="item.total_orders"
                                @click="viewDetail(item)"
                                badge-color="orange"></f7-list-item>
                        </f7-list>
                    </f7-tab>
                </f7-tabs>

                <!-- POPUP -->
                <f7-popup class="demo-popup" :opened="popupOpened" @popup:closed="closePopup">
                    <f7-view>
                        <f7-page>
                            <f7-navbar :title="customer ? customer.name : ''">
                                <f7-nav-right><f7-link popup-close>{{ $ml.get('close') }}</f7-link></f7-nav-right>
                            </f7-navbar>
                            <f7-block strong>
                                <p>{{ $ml.get('total_liabilities') }}: {{ $helper.numFormat(customer ? customer.total_liabilities : 0) }} đ</p>
                            </f7-block>

                            <div v-show="data.length > 0">
                                <f7-card class="demo-card-header-pic" v-for="(so, index) in data" :key="index">
                                    <f7-card-header v-bind:class="{chua_xuat_kho: ! so.code}"
                                        class="no-border"
                                        valign="bottom">{{ so.code ? so.code : $ml.get('doesNotExport') }}</f7-card-header>
                                    <f7-card-content>
                                        <p class="date" v-if="so.exported_at">{{ $ml.get('exportedAt') + ": " + so.exported_at }}</p>
                                        <p class="date" v-if="! so.exported_at && so.estimated_at_format">{{ $ml.get('expectedExport') + ": " + so.estimated_at_format }}</p>
                                        <p class="date" v-if="so.vehicle">{{ $ml.get('soVehicle') + ": " + so.vehicle }}</p>
                                        <ul v-if="so.detail.length > 0">
                                            <li v-for="(detail, index) in so.detail" :key="index" style="font-size: 12px;">{{ detail.material.name + ' (' + detail.packingdetail.name +') - ' + $helper.numFormat(detail.price) + ' đ - SL: ' + $helper.numFormat(detail.amount) }}</li>
                                        </ul>
                                        <p class="date">{{ $ml.get('totalValue') }}: {{ $helper.numFormat(so.total_price) }} đ</p>
                                        <p v-if="so.detail.length === 0">{{ $ml.get('noRecords') }}</p>
                                    </f7-card-content>
                                </f7-card>

                                <f7-block v-if="last_page > page">
                                    <f7-row>
                                        <f7-col></f7-col>
                                        <f7-col>
                                          <f7-button fill @click="viewMore">{{ $ml.get('viewMore') }}</f7-button>
                                        </f7-col>
                                        <f7-col></f7-col>
                                    </f7-row>
                                </f7-block>
                            </div>
                            <f7-card v-if="data.length == 0" :content="$ml.get('noRecords')"></f7-card>
                        </f7-page>
                    </f7-view>
                </f7-popup>
                <!-- END body -->
            </f7-page>
        </f7-view>
    </transition>
</template>

<script>
    import CMNavbar from './Navbar'
    import Query    from '@/services/api/Query'
    import lodash   from 'lodash'

    export default {
        name: 'ListOrders',
        components: {
            'cm-navbar': CMNavbar,
        },
        data() {
            return {
                orders: [],
                data: [],
                customers: [],
                customer: null,
                page: 1,
                popupOpened: false,
                last_page: 0,
            }
        },

        methods: {
            async getData() {
                this.$f7 && this.$f7.dialog.preloader(this.$ml.get('processing'))
                let data  = await Query.withSosByGroup().withCustomers().get()
                this.orders = this.$helper.data(data, 'sos_by_group')
                this.customers = this.$helper.data(data, 'customers')
                this.$f7 && this.$f7.dialog.close()
            },

            async viewDetail(customer) {
                this.$f7 && this.$f7.dialog.preloader(this.$ml.get('processing'))
                this.customer = customer
                let response = this.$helper.data(await Query.withSosByCustomer(customer.id, this.page).get(), 'sos_by_customer')
                this.data = response.data
                this.last_page = response.last_page
                this.popupOpened = true
                this.$f7 && this.$f7.dialog.close()
            },

            async viewMore() {
                if (this.page < this.last_page) {
                    this.page++
                    this.$f7 && this.$f7.dialog.preloader(this.$ml.get('processing'))
                    let response = await Query.withSosByCustomer(this.customer.id, this.page).get()
                    this.data = this.data.concat(this.$helper.data(response, 'sos_by_customer').data)
                    this.$f7 && this.$f7.dialog.close()
                }
            },

            highlight(details) {
                let result = true
                details.forEach(function(item) {
                    if (item.material.materialtype.code !== 'LNLNLS') {
                        result = false
                    }
                })

                return result
            },

            closePopup() {
                this.page = 1
                this.last_page = 0
                this.popupOpened = false
            },
        },

        async created() {
            await this.getData()
        },

        computed: {
            listSort() {
                return lodash.orderBy(this.customers, "total_orders", "desc");
            }
        },
    }
</script>

<style>
    .highlightDay {
        background: green !important;
    }
    .highlightBox {
        background: #cccccc85;
    }
    .chua_xuat_kho {
        color: darkgray !important;
    }
    /*.customer_list ul li {
        display: inline-block;
        width: calc(100%/2 - 40px);
        border: 1px solid;
        position: relative;
        margin: 10px 20px;
    }

    .customer_list.list ul li .item-title {
        white-space: pre-wrap;
        height: 70px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .customer_list.list .item-after {
        position: absolute !important;
        top: -10;
        top: -12%;
        right: -10px;
    }*/
    .list {
        margin-top: 0 !important;
    }
    .__row {
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        display: flex;
        flex-wrap: wrap;
        /*border-bottom: 0.5px solid #9e9e9ebf;;*/
        margin: 0 10px 15px 10px;
        padding: 0 0 15px 0;
    }
    .column > div{
        padding: 15px 0;
        border-bottom: 0.5px solid #9e9e9ebf;


    }
    .column > div:last-child{
        border-bottom: none;
    }
    .column ul {
        padding-left: 0;
    }
    .column ul li {
        font-size: 12px;
        list-style: none;
    }
    .column{
        height: fit-content;
        border: 1px solid gray;
        border-radius: 5px;
        background-color: #fff;
        flex: calc(50% - 15px);
        margin-bottom: 10px;
    }
    .column:nth-child(2n){
        margin-left: 5px;

    }
    .column:nth-child(2n+1){
        margin-right: 5px;

    }
    .column .customer_name{
        font-weight: bold;
    }
    .estimated_day {
        background-color: #007afe;
        min-width: 22px;
        height: 22px;
        border-radius: 50%;
        color: #fff;
        text-align: center;
    }
</style>